import {
    EmailCampaign,
    EmailCampaignBody,
    EmailCampaignsList,
    GetEmailCampaignsParams,
    UpdateEmailCampaignParams,
} from '@/redux/modules/emailCampaigns/emailCampaigns.types';
import { handleResponseV2, makeDelete, makeGet, makePost, makePut } from '@/redux/api/helpers';

type BaseParams = {
    authToken: string;
    deployment: string;
};

export type GetEmailCampaignsResponse = {
    error: boolean;
    payload: EmailCampaignsList;
};

export const getEmailCampaigns = ({ authToken, deployment, ...queryParams }: BaseParams & GetEmailCampaignsParams) =>
    new Promise<GetEmailCampaignsResponse>((resolve, reject) => {
        const request = makeGet({
            apiPath: 'emailCampaigns',
            authToken,
            deployment,
            path: '<SUPPORT-API>',
            queryParams,
        });
        request.end((err, response) =>
            handleResponseV2({
                err,
                reject,
                resolve,
                response,
            })
        );
    });

export type EmailCampaignResponse = {
    error: boolean;
    payload: EmailCampaign;
};

type GetEmailCampaignByIdParams = BaseParams & {
    emailCampaignId: number;
};

export const getEmailCampaignById = ({ authToken, deployment, emailCampaignId }: GetEmailCampaignByIdParams) =>
    new Promise<EmailCampaignResponse>((resolve, reject) => {
        const request = makeGet({
            apiPath: 'emailCampaign',
            authToken,
            deployment,
            path: '<SUPPORT-API>',
            queryParams: { emailCampaignId },
        });
        request.end((err, response) =>
            handleResponseV2({
                err,
                reject,
                resolve,
                response,
            })
        );
    });

export const postEmailCampaign = ({ authToken, deployment, ...body }: BaseParams & EmailCampaignBody) =>
    new Promise<EmailCampaignResponse>((resolve, reject) => {
        const request = makePost({
            apiPath: 'emailCampaign',
            authToken,
            deployment,
            path: '<SUPPORT-API>',
        });
        request.send(body);
        request.end((err, response) =>
            handleResponseV2({
                err,
                reject,
                resolve,
                response,
            })
        );
    });

/**
 * The full campaign must be sent on every update, not only the fields that changed
 */
export const putEmailCampaign = ({
    authToken,
    deployment,
    emailCampaignId,
    ...body
}: BaseParams & UpdateEmailCampaignParams) =>
    new Promise<EmailCampaignResponse>((resolve, reject) => {
        const request = makePut({
            apiPath: 'emailCampaign',
            authToken,
            deployment,
            path: '<SUPPORT-API>',
            queryParams: { emailCampaignId },
        });
        request.send(body);
        request.end((err, response) =>
            handleResponseV2({
                err,
                reject,
                resolve,
                response,
            })
        );
    });

export type DeleteEmailCampaignResponse = {
    error: boolean;
    payload: boolean;
};

type DeleteEmailCampaignByIdParams = BaseParams & {
    emailCampaignId: number;
};

export const deleteEmailCampaignById = ({ authToken, deployment, emailCampaignId }: DeleteEmailCampaignByIdParams) =>
    new Promise<DeleteEmailCampaignResponse>((resolve, reject) => {
        const request = makeDelete({
            apiPath: 'emailCampaign',
            authToken,
            deployment,
            path: '<SUPPORT-API>',
            queryParams: { emailCampaignId },
        });
        request.end((err, response) =>
            handleResponseV2({
                err,
                reject,
                resolve,
                response,
            })
        );
    });
